<template>
  <div>
    <Radar id="jiaotongtongda" :chartData="chartData" />
  </div>
</template>

<script>
import Radar from "@/components/Echarts/Radar.vue";

export default {
  name: "JiaotongTongdaFenxi",
  props: {
    chartData: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  components: {
    Radar
  },
  data() {
    return {};
  },
  mounted() {}
};
</script>

<style scoped lang="less"></style>
